
import {
  CREATE_FORM,
  ENTITY_REGISTER,
  GET_ENTITY_TYPE_FORMS,
  GET_ASSIGNED_SUB_ENTITIES_URL,
  LIST_PROJECT_TEMPLATE_URL,
  ASSIGN_TEMPLATE_ENTITY_FORM_URL,
  UNASSIGN_TEMPLATE_ENTITY_FORM_URL,
  GET_ASSIGNED_ENTITY_FORMS_URL,
  get_headers,
  UPDATE_FORM,
  GET_ALL_FORM_TYPES,
} from '@/utils/constants/constants.js';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';
import { validate_non_empty_string, validate_non_sub_zero_number } from '@/utils/validations/validate_inputs';
import CreateComplianceRequirements from '@/views/probaworkflows_base/management/compliance_management/compliance_overview/ComplianceOverview.vue';
import ManageApprovalRules from '@/views/probaworkflows_base/management/entity_management/approval_rules_management/manage_approval_rules/ManageApprovalRules.vue';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { nextTick } from 'vue';
 
export default {
  name: 'CreateForms',
  props: {
    entity_type_name: {
      type: String,
      required: false,
      default: ''
    },
  },
  mixins: [alert_mixin ,formatting_mixins],
  components: {
    ManageApprovalRules,
    CreateComplianceRequirements,
  },
  data: () => ({
    headers: get_headers(),
      project_id: sessionStorage.getItem('project_id'),
      entity_type_id: sessionStorage.getItem('entity_type_id'),
      entity_type_name: sessionStorage.getItem('entity_type_name'),
      selected_form_id: '',
      active_tab: 'Forms',
      tabs: ['Forms', 'Template', 'Approval Rules', 'Invoice Steps', 'Compliance'],
      email: '',
      form_list: [],
      form_table_headers: [],
      table_safe_form_list: [],
      manage_template: [],
      manage_approval_rules: [],
      manage_invoice_steps: [],
      manage_compliance: [],
      document_url: null,
      form_name: '',
      form_description: '',
      dataTable: null, // To store DataTable instance
      form_id: null,
      available_children: [],
      datatable_key: 0,
      main_form: {
        form_name: '',
        description: ''
      },
      sub_entity_forms: [],
      form_types: [],
      form_type_id: null,
  }),
  computed: {
    filtered_data() {
      switch (this.active_tab) {
        case 'Manage Forms': return this.form_list;
        case 'Manage Template': return this.manage_template;
        case 'Manage Approval Rules': return this.manage_approval_rules;
        case 'Manage Invoice Steps': return this.manage_invoice_steps;
        case 'Manage Compliance': return this.manage_compliance;
        default: return [];
      }
    }
  },
  mounted() {
    this.headers = get_headers();
    this.get_forms();
    const saved_tab = sessionStorage.getItem('active_tab');
    if (saved_tab && this.tabs.includes(saved_tab)) {
      this.active_tab = saved_tab;
    }
    this.initialize_data_table();
    this.ensure_form_types_loaded();
  },
  methods: {
    async set_active_tab(tab) {
      this.active_tab = tab;
      sessionStorage.setItem('active_tab', tab);
      await nextTick();
      this.get_forms();
      this.initialize_data_table();
    },
   
    go_back() {
      this.$router.push('/manage_entity_type');
    },
 
    initialize_data_table() {
      this.$nextTick(() => {
        const table_ids = {
          'Manage Forms': '#manage-forms-table',
          'Manage Template': '#manage-template-table',
          'Manage Approval Rules': '#manage-approval-rules-table',
          'Manage Invoice Steps': '#manage-invoice-table',
          'Manage Compliance': '#manage-compliance-table'
        };
 
        const table_id = table_ids[this.active_tab];
       
        // Add null check before trying to access the DOM element
        const table_element = document.querySelector(table_id);
        if (!table_element) {
          return; // Exit if element doesn't exist
        }
 
        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }
        $(table_id).DataTable(); // Reinitialize DataTable
      });
    },

    redirect_to_create_entity(form) {
      sessionStorage.setItem('form_id', form.id);
      sessionStorage.setItem('form_type', form.form_type_name || '');

      this.$router.push({
        path: '/create_entity',
        query: {
          form_id: form.id,
          entity_type_name: this.entity_type_name, // Pass entity type name
        },
      });
    },
   
    redirect_to_upload_template() {
      this.$router.push('/upload_template');
    },
   
    set_document_url(template) {
      this.document_url = template.document_url || null;
    },
   
    edit_template() {
      this.show_success('Template edited successfully.');
    },
 
    delete_template_file() {
      Swal.fire({
        title: "Are you sure you want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },

    async ensure_form_types_loaded() {
      if (Array.isArray(this.form_types) && this.form_types.length) return; // already loaded
      try {
          const { data } = await axios.get(GET_ALL_FORM_TYPES, { headers: this.headers });
          if (data?.status === 'success') {
          this.form_types = data.data || [];
          } else {
          this.form_types = [];
          this.show_error('Failed to load form types.');
          }
      } catch (err) {
          this.form_types = [];
          this.show_error('Failed to load form types: ' + (err.response?.data?.message || err.message));
      }
    },
    get_forms() {

      var query_params = {
        entity_type_id: this.entity_type_id,
      }
 
      axios.get(GET_ENTITY_TYPE_FORMS, {
        headers: this.headers,
        params: query_params
      })
        .then(response => {
          const parsed_response = JSON.parse(response.data);
          if (parsed_response.data && parsed_response.data.length > 0) {
            this.form_list = parsed_response.data;
            this.prep_tables();
          }
        })
        .catch(error => {
            this.show_error('Error getting forms: ' + error);
            return;
        });
    },

     
    initialize_forms_data_table() {
        this.$nextTick(() => {
            const table_id = '#form_management_table';
            const table = $(table_id);

            if (table.length === 0) {
                return;
            }
            
            // Destroy the existing DataTable instance if it exists
            if ($.fn.DataTable.isDataTable(table)) {
                table.DataTable().clear().destroy();
            }
            
            // Store the DataTable instance
            this.dataTable = table.DataTable({
                responsive: true,
                autoWidth: false,
                pageLength: 10
            });
        });
    },
 
    prep_tables() {
      if (this.form_list.length > 0) {
        const table_safe_form_list = this.form_list.map(form => ({
          "id" : form.id,
          "entity_type_id": form.entity_type_id,
          "Form": form.form_name,
          "Description": form.form_description,
          "Status": form.status,
          "Date Created": this.format_date(form.date_created),
          "form_type_id": form.form_type ? form.form_type.id : null,
          "form_type_name": form.form_type ? form.form_type.form_type : null,
      }));
        
        this.form_table_headers = Object.keys(table_safe_form_list[0]);
        this.table_safe_form_list = table_safe_form_list;
      }
      this.initialize_forms_data_table()
    },
 
    create_form() {
      if (!validate_non_empty_string(this.form_name)) {
        this.show_error('Form name is required.');
        return;
      }
 
      if (this.form_description !== '') {
        if (!validate_non_empty_string(this.form_description)) {
          this.show_error('Form description');
          return;
        }
      }
 
      const payload = {
        project_id: this.project_id,
        form_name: this.form_name,
        form_description: this.form_description || null,
        entity_type_id: this.entity_type_id,
        form_type_id: this.form_type_id || null,
      };
 
      axios.post(CREATE_FORM, payload, { headers: this.headers })
                      .then(response => {
                          const response_data = JSON.parse(response.data);

                          if (response_data.status === 'success') {
                              this.close_modal('create_form');
                              this.show_success(`Form ${this.form_name} created successfully.`);
                              sessionStorage.setItem('form_name', this.form_name);
                              this.get_forms();
                              window.location.reload();
                          } else {
                              this.show_error('Error creating entity form: ' + "Form already exists");
                              this.close_modal('create_form');
                          }
                      })
                      .catch(error => {
                          this.show_error('Error creating form: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                          this.close_modal('create_form');
                      });
    },

    async open_edit_modal(form) {

      await this.ensure_form_types_loaded();
      this.form_id = form.id;
      this.form_name = form["Form"];
      this.form_description = form["Description"];
      this.form_type_id = form["form_type_id"];

      if (!this.form_type_id && this.form_types.length) {
        this.form_type_id = this.form_types[0].id;
      }
    },

    update_form() {
      if (!validate_non_empty_string(this.form_name)) {
          this.show_error('Form name is required.');
          return;
      }
      if (this.form_description !== '' &&
          !validate_non_empty_string(this.form_description)) {
          this.show_error('Form description is required.');
          return;
      }
      if (!validate_non_sub_zero_number(this.form_type_id)) {
        this.show_error('Please choose a valid form type.');
        return;
      }


      const payload = {
          form_id: this.form_id,
          form_name: this.form_name,
          form_description: this.form_description,
          form_type_id: this.form_type_id,
      };

      axios.post(UPDATE_FORM, payload, { headers: this.headers })
          .then(response => {
          const response_data = JSON.parse(response.data);
          const { status, message } = response_data;
          if (status === 'success') {
              this.close_modal('edit_form');
              window.location.reload();
              this.show_success('Entity form updated successfully.');
          } else {
              this.show_error('Error updating form: ' + (message || 'Unknown error'));
              this.close_modal('edit_form');
          }
          })
          .catch(error => {
          this.show_error('Error updating form: ' + (error.response?.data?.message || 'An unexpected error occurred'));
          this.close_modal('edit_form');
          });
    },


   
    share_trust_setup() {
      if (!validate_non_sub_zero_number(parseInt(this.selected_form_id, 10))) {
        this.show_error('Please select a form to share');
        return;
      }
    
      if (!this.email || !this.email.includes('@')) {
        this.show_error('Please enter a valid email address');
        return;
      }
    
      const data = {
        form_id: parseInt(this.selected_form_id, 10),
        email: this.email,
        project_id: this.project_id,
        entity_type_id: this.entity_type_id,
      };
    
      axios.post(ENTITY_REGISTER, data, { headers: this.headers })
        .then(response => {
          if (response.data) {
            this.show_success('Entity form successfully shared.');
            this.close_modal('share_trust_form');
            this.email = '';
          }
        })
        .catch(error => {
          this.show_error(error.response?.data?.message || 'Error sharing the form');
          this.close_modal('share_trust_form');
        });
    }
    ,
 
    async selected_share_form_id(form_id) {
      this.selected_form_id = form_id;

      const form = this.form_list.find(f => f.id === parseInt(form_id, 10));
      if (form) {
        this.main_form = {
          form_name: form.form_name,
          description: form.form_description
        };
      }

      this.get_assigned_sub_entities(form_id).then(sub_forms => {
        this.sub_entity_forms = sub_forms.map(sub => ({
          id: sub.id,
          form_name: sub.sub_entity_name || "Unnamed Sub-Form",
        }));
      });
    },
 
    redirect_to_manage_assigned_workflows(form_id) {
      this.selected_form_id = form_id;
      sessionStorage.setItem('form_id', form_id);
      const form = this.form_list.find(forms => forms.id === parseInt(form_id, 10));
      if (form) {
        sessionStorage.setItem('form_name', form.form_name);
        this.$router.push({
          path: "/manage_assigned_workflows",
          query: { form_id: form_id },
        });
      }
     
    },

    get_assigned_sub_entities(form_id) {
      return axios.get(GET_ASSIGNED_SUB_ENTITIES_URL, {
        headers: this.headers,
        params: { form_id }
      })
      .then(res => {
        return res.data.data || [];
      })
      .catch(() => {
        return [];
      });
    },

    async opening_assign_modal(row) {
      //Capture IDs safely
      this.selected_form_id = row?.id || null;
      const entity_type_id = row?.entity_type_id || this.entity_type_id;

      if (!this.project_id || !this.selected_form_id || !entity_type_id) {
        this.show_error("Missing required IDs (project, form, or entity type).");
        return;
      }

      // Reset table data
      this.available_children = [];
      this.datatable_key = Date.now();

      try {
        //Fetch templates
        const templates_response = await axios.get(LIST_PROJECT_TEMPLATE_URL, {
          headers: this.headers,
          params: { project_id: this.project_id },
        });

        if (!templates_response?.data || templates_response.data.status !== "success") {
          this.show_error("Unable to fetch project templates.");
          return;
        }

        const templates = templates_response.data.data || [];

        if (templates.length === 0) {
          this.show_error("No templates available for this project.");
          return;
        }

        //Find matching template_entity_type_id
        let matching_template_entity_type_id = null;
        for (const template of templates) {
          const match = (template.template_entity_types || []).find(
            (entity_type) => Number(entity_type.entity_type_id) === Number(entity_type_id)
          );
          if (match) {
            matching_template_entity_type_id = match.id;
            break;
          }
        }

        if (!matching_template_entity_type_id) {
          this.show_error("No matching template found for this Entity Type.");
          return;
        }

        //Fetch already-assigned templates
        const assigned_response = await axios.get(GET_ASSIGNED_ENTITY_FORMS_URL, {
          headers: this.headers,
          params: {
            form_id: this.selected_form_id,
            entity_type_id: entity_type_id,
            template_document_entity_type_id: matching_template_entity_type_id,
          },
        });

        const assigned_data = assigned_response?.data?.data || [];

        // Extract active template IDs
        const assigned_template_ids = assigned_data
          .filter((item) => item.is_active)
          .map((item) => item.template_id);

        //Merge templates + assigned state
        this.available_children = templates.flatMap((template) =>
          (template.template_entity_types || [])
            .filter(
              (entity_type) => Number(entity_type.entity_type_id) === Number(entity_type_id)
            )
            .map((entity_type) => ({
              id: entity_type.id, // TemplateDocumentEntityType.id
              template_id: template.id, // TemplateDocument.id
              template_name: template.name,
              entity_type_id: entity_type.entity_type_id,
              is_assigned: assigned_template_ids.includes(template.id),
              is_loading: false,
            }))
        );

        if (this.available_children.length === 0) {
          this.show_error("No template-entity matches found for this Entity Type.");
        }
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          "Unexpected error fetching templates.";
        this.show_error(msg);
      }
    },


    async on_toggle_assign(child, evt) {
      const target_checked = evt.target.checked;

      const form_id = Number(this.selected_form_id);
      const template_document_entity_type_id = Number(child.id);

      if (!form_id || !template_document_entity_type_id) {
        evt.target.checked = !target_checked;
        this.show_error("Missing form or template id.");
        return;
      }

      child.is_loading = true;

      try {
        const url = target_checked
          ? ASSIGN_TEMPLATE_ENTITY_FORM_URL
          : UNASSIGN_TEMPLATE_ENTITY_FORM_URL;

        const payload = {
          entity_type_form_id: form_id,
          template_document_entity_type_id,
          entity_type_id: child.entity_type_id
        };

        const response = await axios.post(url, payload, { headers: this.headers });

        if (response.data.status === "success") {
          child.is_assigned = target_checked;
          this.show_success(response.data.message);
        } else {
          evt.target.checked = !target_checked;
          this.show_error(response.data.message);
        }
      } catch (error) {
        evt.target.checked = !target_checked;
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          "Error updating assignment.";
        this.show_error(msg);
      } finally {
        child.is_loading = false;
      }
    },

  }
};